import axiosInstance from '@/services/axiosInstance'

export async function createProducto (producto) {
  try {
    const res = await axiosInstance.post(
      process.env.VUE_APP_URL_API_BASE + '/sincData/createProducto',
      { products: [producto] }, // este es el body
      {
        headers: {
          Authorization: 'Basic ' + process.env.VUE_APP_BASIC_AUTHORIZATION_API
        }
      }
    )
    return res.data
  } catch (error) {
    console.error('Error al crear producto:', error)
    throw error
  }
}
